import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
// import { Axios } from 'axios';

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

axios.defaults.headers.common['Content-Type'] = 'application/json';

const app = createApp(App)
const options = {
    confirmButtonColor: '#007bff',
    cancelButtonColor: '#6c757d',
};

app.use(VueAxios, axios);

app.use(VueSweetalert2, options);

app.config.productionTip = false

// app.use(router) // Usa el enrutador
// .use(store)

createApp(App)
.use(router)
.mount('#app')